import React, { useState, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
// import Lottie from "react-lottie-player";
import { LifeBuoy } from "lucide-react";
// import supportAnimation from "../../assets/support.json";

const faqs = [
  {
    question: "How do I reset my password?",
    answer: "Go to the login page and click on 'Forgot Password'. Follow the instructions to reset your password.",
  },
  {
    question: "How can I track my fitness goals?",
    answer: "Navigate to the dashboard and you'll see your goal progress and suggestions to stay on track.",
  },
  {
    question: "Is FitTrack free to use?",
    answer: "FitTrack has both free and premium features. You can use most tracking features for free!",
  },
  {
    question: "How do I contact customer support?",
    answer: "You can email us at support@fittrack.com or use the contact form at the bottom of this page.",
  },
];

const accordionVariant = {
  hidden: { height: 0, opacity: 0 },
  visible: { height: "auto", opacity: 1 },
};

export default function Support() {
  const [search, setSearch] = useState("");
  const [openIndex, setOpenIndex] = useState(null);
  const [isLoading, setIsLoading] = useState(true);

  const filteredFaqs = faqs.filter((faq) =>
    faq.question.toLowerCase().includes(search.toLowerCase())
  );

  useEffect(() => {
    const timer = setTimeout(() => setIsLoading(false), 1500);
    return () => clearTimeout(timer);
  }, []);

  return (
    <div className="relative min-h-screen bg-[#0e1a10] text-white px-6 py-20 font-manrope overflow-hidden">

      
      <div className="absolute inset-0 z-0 pointer-events-none overflow-hidden">
        <div className="absolute top-10 left-20 w-40 h-40 bg-green-300 rounded-full blur-2xl opacity-10 animate-pulse" />
        <div className="absolute bottom-10 right-20 w-52 h-52 bg-blue-400 rounded-full blur-3xl opacity-10 animate-ping" />
      </div>

      <div className="relative max-w-6xl mx-auto z-10">
  {isLoading ? (
    <div className="w-2/3 h-12 mx-auto rounded-lg bg-[#1a2a1c] animate-pulse mb-10" />
  ) : (
        <motion.h1 className="... flex justify-center items-center gap-3 ">
  <LifeBuoy className="text-green-400" size={36} />
  <span>Need Help? We're Here!</span>
</motion.h1>
)}
        
        <div className="mb-10 flex justify-center">
          {isLoading ? (
            <div className="w-full max-w-xl h-12 bg-[#1c2a22] rounded-lg animate-pulse" />
          ) : (
            <input
              type="text"
              placeholder="Search FAQs..."
              value={search}
              onChange={(e) => setSearch(e.target.value)}
              className="w-full max-w-xl px-4 py-3 rounded-lg bg-[#1b2b22] border border-green-500 placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-green-400 text-white"
            />
          )}
        </div>

        {/* FAQ Skeleton or Accordion */}
        <div className="space-y-4">
          {isLoading ? (
            Array(4).fill(0).map((_, index) => (
              <div key={index} className="bg-[#1a2b1d] p-5 rounded-lg animate-pulse h-24" />
            ))
          ) : filteredFaqs.length > 0 ? (
            filteredFaqs.map((faq, index) => (
              <motion.div
                key={index}
                className="bg-[#1a2b1d] border border-white/10 rounded-lg shadow-sm overflow-hidden"
                initial={{ opacity: 0, y: 10 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ delay: index * 0.1 }}
              >
                <button
                  className="w-full text-left px-6 py-4 text-lg font-semibold text-green-400 hover:bg-[#223322] transition"
                  onClick={() => setOpenIndex(openIndex === index ? null : index)}
                >
                  {faq.question}
                </button>

                <AnimatePresence initial={false}>
                  {openIndex === index && (
                    <motion.div
                      key="content"
                      variants={accordionVariant}
                      initial="hidden"
                      animate="visible"
                      exit="hidden"
                      className="px-6 py-3 text-gray-300"
                    >
                      {faq.answer}
                    </motion.div>
                  )}
                </AnimatePresence>
              </motion.div>
            ))
          ) : (
            <p className="text-center text-gray-400">No matching FAQs found.</p>
          )}
        </div>

       
        {/* <div className="relative w-full max-w-md mx-auto mt-16 z-0">
          <Lottie
            loop
            play
            animationData={supportAnimation}
            className="w-full h-auto opacity-70"
          />
        </div> */}

       
        <div className="text-center mt-16">
          <p className="text-gray-300">
            Still need help?{" "}
            <a
              href="mailto:support@fittrack.com"
              className="text-green-400 underline hover:text-green-300"
            >
              Contact us directly.
            </a>
          </p>
        </div>
      </div>
    </div>
  );
}
